import React, { } from "react";
import { Dimensions, StyleSheet, View } from "react-native";
import Route from "./src/route/route";
import { useFonts } from "expo-font";
import { RecoilRoot } from "recoil";
const { width, height } = Dimensions.get("window");

if (!__DEV__) {
  console = {
    log: () => { },
    warn: () => { },
    error: () => { },
  };
}

const App = () => {
  const [loaded] = useFonts({
    "Prompt-Regular": require("./assets/fonts/Prompt-Regular.ttf"),
    "Prompt-Bold": require("./assets/fonts/Prompt-Bold.ttf"),
  });

  if (!loaded) {
    return null;
  }

  return (
    <RecoilRoot>
      <View style={styles.container}>
        <Route />
      </View>
    </RecoilRoot>
  );
};
export default App;

const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#ff0000",
  },
});
